import { Grid2, Typography } from '@mui/material'
import Container from '../../../components/Container'
import { useNavigate } from 'react-router-dom'
import BranchCardSkeleton from '../../../components/Skeletons/BranchCardSkeleton'
import BranchCard from '../../../components/Cards/BranchCard'
import { memo, useEffect, useState } from 'react'
import { IBranch } from 'sierra'
import api from '../../../utils/axios'
import socket from '../../../utils/socket'
import { useApp } from '../../../contexts/AppContext'

const Branches = memo(() => {
    const navigate = useNavigate()
    const { translate } = useApp()

    const [branches, setBranches] = useState<IBranch[] | null>(null)

    const fetchBranches = () => {
        api.get('/branches').then(res => {
            setBranches(res.data)
        }).catch(console.error)
    }

    useEffect(() => {
        fetchBranches()
        socket.on("branches_changed", fetchBranches);
        socket.on("translations_changed", fetchBranches);
        return () => {
            socket.off("branches_changed", fetchBranches);
            socket.off("translations_changed", fetchBranches);
        }
    }, [])

    return (
        <Grid2 container size={'grow'} flexDirection={'column'} spacing={2}>

            <Container container size={'auto'} padding={2} justifyContent={'space-between'}>
                <Typography variant='h5' fontWeight={'bold'} color='primary'>
                    {translate("Choose a Branch:")}
                </Typography>
            </Container>

            <Container container flexDirection={'column'} overflow={'hidden'} spacing={2} padding={2}>
                <Grid2 container padding={2} sx={{ overflowX: 'hidden', overflowY: 'auto' }}>
                    {!branches ? Array.from({ length: 3 }).map((a, i) => <BranchCardSkeleton hideButtons key={i} />) : branches.length == 0 ? <Typography>No Branches</Typography> :
                        branches
                            // .concat(branches).concat(branches)
                            .map((b, i) =>
                                <BranchCard key={i} branch={b} hideButtons clickable index={location.pathname.split('/')[3] ? undefined : i} />
                            )}
                </Grid2>
                <Grid2 size={'grow'} />
            </Container>

        </Grid2>)
})

export default Branches